var _a;
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/ar';
import 'dayjs/locale/en';
import i18n from 'i18next';
dayjs.locale((_a = i18n.language) !== null && _a !== void 0 ? _a : 'en');
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
export var getDiffFromNow = function (date) {
    var lang = (i18n === null || i18n === void 0 ? void 0 : i18n.language) || 'en';
    var formattedDate = dayjs(date.toString()).format('YYYY-MM-DD');
    return dayjs(formattedDate).locale(lang).fromNow(true);
};
export var getCurrentDate = function () {
    return dayjs();
};
export var addDays = function (date, days) {
    return dayjs(date.toString()).add(days, 'day');
};
export var subtractDays = function (date, days) {
    return dayjs(date.toString()).subtract(days, 'day');
};
export var isSameDay = function (date1, date2) {
    return dayjs(date1.toString()).isSame(dayjs(date2.toString()), 'day');
};
export var formatDate = function (date, format) {
    return dayjs(date.toString()).format(format);
};
export var startOfDayForDate = function (date) {
    return dayjs(date.toString()).startOf('day');
};
export var endOfDayForDate = function (date) {
    return dayjs(date.toString()).endOf('day');
};
